// extracted by mini-css-extract-plugin
export default {"container":"styles_container__j7WvH","footer":"styles_footer__sW58c","bigButton":"styles_bigButton__jchYi","smallButton":"styles_smallButton__F96Uz"};